<ng-container *ngIf="authStoreState$ | async as state">
  <vi-toolbar *ngIf="router.url !== '/home'" head color="viorange" class="app-toolbar">
    <vi-sidenav-button
      data-at-menu-button
      left
      *ngIf="(headerType === 'full' || headerType === 'rsa') && !router.url.startsWith('status')"
      gtm="onOpen"
      gtmAction="Menu"
      gtmCategory="navbar"
    ></vi-sidenav-button>
    <div left>
      <div *appShowForRsaUser>
        <vi-logo (click)="redirect()" [isRsa]="true"></vi-logo>
      </div>
      <div *appHideForRsaUser>
        <vi-logo (click)="redirect()"></vi-logo>
      </div>
    </div>
    <button
      right
      data-at-demo-settings
      *ngIf="state.demo && !environment.env.includes('production')"
      mat-raised-button
      color="primary"
      gtm="onGoToPage"
      gtmAction="Feature settings"
      gtmCategory="Demo"
      routerLink="/demo-settings"
      routerLinkActive="hide"
    >
      {{ 'GENERAL.BUTTON.DEMO_FEATURES' | translate }}
    </button>
    <button
      right
      data-at-exit-demo
      *ngIf="state.demo"
      mat-raised-button
      color="primary"
      gtm="onGoToPage"
      gtmAction="Landing page"
      gtmCategory="Demo"
      (click)="authStore.exitDemo()"
    >
      {{ 'GENERAL.BUTTON.EXIT_DEMO' | translate }}
    </button>
    <ng-container right *ngIf="searchIconVisible && !router.url.startsWith('status')">
      <vi-icon-button
        gtm="onGoToPage"
        gtmAction="Search page"
        gtmCategory="navbar"
        *appShowForRsaUser
        routerLink="/search"
        >search</vi-icon-button
      >
    </ng-container>

    <app-invitation-notification
      right
      *ngIf="headerType === 'full' && !router.url.startsWith('status')"
      gtm="onGoToPage"
      gtmAction="Invitations"
      gtmCategory="navbar"
    ></app-invitation-notification>

    <div right *appHideForRsaUser>
      <app-service-ticket
        *ngIf="
          headerType === 'full' &&
          !router.url.startsWith('status') &&
          (authStore.serviceTicketAccess$ | async)
        "
        gtm="onGoToPage"
        gtmAction="Service Ticket"
        gtmCategory="navbar"
      ></app-service-ticket>
    </div>

    <!-- global header -->
    <div
      right
      class="flex flex-row"
      *ngIf="(languageStore.isLoaded$ | async) && state.authenticated"
    >
      <ng-container *ngIf="languageStore.languageCode$ | async as languageCode">
        <dsw-app-switcher
          *ngIf="state?.me?.id && !state.demo"
          gtm="onOpen"
          gtmAction="More apps menu"
          gtmCategory="navbar"
          [lang]="languageCode"
          [appSwitcherContent]="apps$ | async"
        ></dsw-app-switcher>
        <dsw-login
          *ngIf="!state.demo && !isViGuideMonitoring"
          gtm="onAuthentication"
          [isLoggedIn]="authStore.authenticated$ | async"
          (logoutEvent)="onLogout()"
          [lang]="languageCode"
        ></dsw-login>
      </ng-container>
    </div>
  </vi-toolbar>

  <mat-progress-bar mode="indeterminate" head class="post-loader"></mat-progress-bar>

  <ng-container body>
    <vi-loader
      class="check-user-loader"
      *ngIf="state.authenticating || state.authorizing || !translationsLoaded"
      body
      [isLoading]="true"
      message="{{ '+HOME.LOADING_MESSAGE.CHECK_USER' | translate }}"
    ></vi-loader>
  </ng-container>

  <router-outlet
    *ngIf="!state.authenticating && !state.authorizing && translationsLoaded"
  ></router-outlet>
</ng-container>
